module.exports = __webpack_public_path__ + "static/about-catalog-6a01894bb93720e073f699a817906dae.svg";